module.exports = __webpack_public_path__ + "img/ABT.f8d59ed8.jpg";